import Error403 from 'pages/Error/Error403';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from 'store';

const ifConfigured = (WrappedComponent: React.FC, configurationKey: string, redirectTo?: string): React.FC => {
    return (props: any) => {

        const configruations = useSelector((state: RootState) => state.auth.configurations);

        if (configruations[configurationKey] !== 'y') {
            if (redirectTo) {
                return <Navigate to={redirectTo} />
            }
            return <Error403 />
        }

        return <WrappedComponent {...props} />;
    };
};

export default ifConfigured;